module.exports = __webpack_public_path__ + "media/images/samples/1280x768/12-a7771aa5c9ea541cb61015d661bf2dc7.jpg";